import { Component, OnInit, OnDestroy, Input, Output, NgZone, Inject, EventEmitter } from '@angular/core';
import { Response } from '@angular/http';
import { NgUploaderOptions, UploadedFile, UploadRejected } from 'ngx-uploader';

import {ModelImage} from '../../entities/model-image/model-image.model';
import {Model} from '../../entities/model/model.model';
import {ImageResource} from '../../entities/image-resource/image-resource.model';
import {CSRFService} from '../../shared/auth/csrf.service';
import {Subject} from 'rxjs/Subject';
import {JhiTranslateComponent} from 'ng-jhipster/src/language/jhi-translate.directive';
import {TranslatePartialLoader} from 'ng-jhipster/index';
import {SellerDashboardService} from './seller-dashboard.service';
import {AlertService} from 'ng-jhipster/src/service/alert.service';

@Component( {
    selector: 'dcs-seller-model-image',
    templateUrl: './seller-model-image.component.html',
    styles: [ `
    .device-img {
        width: 15rem;
        height: 22rem;
        margin-top: 2rem;
        margina-left: 3rem;
    }
    .drag-n-drop-container {
        border: dotted 3px black ;
        width: 15rem;
        height: 22rem;
        text-align: center;
        padding: 1rem
    }
    .hidden { display:none }
    .file-over { border: dotted 3px red; }
    .upload-button{
        width: 200px;
        display: block;
        outline: none;
        border-radius: 10px;
        background: #111;
        color: #fff;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 1rem;
        text-align: center;
        padding: 10px 50px;
        border: 1px solid #111;
        margin: 20px 3rem 1rem 0

}
    ` ]
} )
export class SellerModelImageComponent implements OnInit, OnDestroy {
    @Input()
    image: ImageResource;
    @Input()
    model: Model;
    @Input()
    type: string;
    @Input()
    description: string;
    private subscriber = new Subject<ImageData>()

    @Output()
    reload: EventEmitter<boolean> = new EventEmitter<boolean>();

    private imageData: ImageData;


    hasBaseDropZoneOver: boolean;
    options: NgUploaderOptions;
    response: any;
    sizeLimit: number = 5;
    sizeLimitBytes: number = this.sizeLimit * 1024 * 1024; // 10MB
    showProgress: boolean = false;
    previewData: any;
    errorMessage: string;
    inputUploadEvents: EventEmitter<string>;

    constructor(@Inject( NgZone ) private zone: NgZone,
                private sellerService: SellerDashboardService,
                private alertService: AlertService,
                private csrfService: CSRFService) {
    }

    ngOnInit() {
        this.options = new NgUploaderOptions( {
            url: '/api/dashboard/seller/model/' + this.model.id + '/upload/image/' + this.type,
            filterExtensions: true,
            allowedExtensions: [ 'png', 'jpg', 'jpeg' ],
            // maxSize: 2097152,
            autoUpload: false,
            calculateSpeed: true,
            fieldName: this.type,
            fieldReset: true,
            maxUploads: 20,
            method: 'POST',
            multipart: true,
            // previewUrl: true,
            customHeaders: {
                'X-XSRF-TOKEN': this.csrfService.getCSRF()
            },
        } );
        this.subscriber.subscribe( (imageData: ImageData)=> {
            this.imageData = imageData;
            this.inputUploadEvents.emit( 'startUpload' );
        } );
        this.inputUploadEvents = new EventEmitter<string>();
    }

    ngOnDestroy(): void {
        this.subscriber.unsubscribe();
    }

    startUpload() {
        this.inputUploadEvents.emit( 'startUpload' );
    }

    beforeUpload(uploadingFile: UploadedFile, arg: any): void {

        if (uploadingFile.size > this.sizeLimitBytes) {
            uploadingFile.setAbort();
            this.errorMessage = 'deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.error.fileToBig';
        }
        else if (this.model.screenHeight !== this.imageData.height || this.model.screenWidth !== this.imageData.width) {
            console.log(this.imageData)
            uploadingFile.setAbort();
            this.errorMessage = 'deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.error.improperImageResolution';
        }
        else{
            this.showProgress = true;
        }
    }


    handleUpload(data: any) {
        setTimeout( () => {
            this.zone.run( () => {
                this.response = data;
                console.log( this.response )
                if (data && data.response && data.status == 200) {
                    this.response = JSON.parse( data.response );
                    this.image = JSON.parse( data.response );
                }
            } );
        } );
    }

    fileChanged(event) {
        let _URL = window.URL;
        let whObservable = this.subscriber;

        //console.log( event.target.files[ 0 ] );
        let file, img;
        if ((file = event.target.files[ 0 ])) {
            img = new Image();
            img.onload = function () {
                let imageData = new ImageData;
                imageData.height = this.height;
                imageData.width = this.width;
                whObservable.next( imageData )
            };
            img.src = _URL.createObjectURL( file );
        }

    }

    handlePreviewData(data: any) {
        this.previewData = data;
    }

    fileOverBase(e: boolean) {
        this.hasBaseDropZoneOver = e;
    }

    getFile() {
        return `data:image/png;base64,${this.image.file}`;
    }


    removeImage() {
        //console.log(this.image)

        let c = confirm( "Are you sure to remove the image?" );
        if (c) {
            this.sellerService.removeImage( this.image.id, this.type ).subscribe(
                (res: Response) => {
                    if (res.ok) {
                        this.reload.emit( true );

                    }
                }, (res: Response) => this.onError( res.json() ) );
            ;
        }
    }

    private onError(error) {
        this.alertService.error( error.message, null, null );
    }

}
export class ImageData {
    constructor(public width?: number,
                public height?: number) {
    }
}

export interface UploadFile {
    id: string; // unique id of uploaded file instance
    fileIndex: number; // fileIndex in internal ngx-uploader array of files
    lastModifiedDate: Date; // last modify date of the file (Date object)
    name: string; // original name of the file
    size: number; // size of the file in bytes
    type: string; // mime type of the file
    progress: UploadProgress;
    response?: any; // response when upload is done (parsed JSON or string)
}

export interface UploadProgress {
    status: number; // current status of upload for specific file (Queue | Uploading | Done | Canceled)
    data?: {
        percentage: number; // percentage of upload already completed
        speed: number; // current upload speed per second in bytes
        speedHuman: string; // current upload speed per second in human readable form
    };
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/dashboard/seller-dashboard/seller-model-image.component.ts